export interface InscriptionDTO {
  id?: string;
  eleveId: string;
  classeId: string;
  classeName?: string;
  ecoleId: string;
  anneeScolaireId: string;
  anneeScolaireName?: string;
  dateInscription?: string;
  montantInscription?: number;
  statutInscription: StatutInscription | 'NON_INSCRIT';
  supportId?: string;
}

export enum StatutInscription {
  EN_ATTENTE = 'EN_ATTENTE',
  INSCRIT = 'INSCRIT',
  SUSPENDUE = 'SUSPENDUE',
  DESINSCRIT = 'DESINSCRIT',
  TERMINEE = 'TERMINEE',
}
